import { Fraction } from 'src/models/helperTypes/FractionationType';
import { ANNUAL, OTHER } from 'src/constants/paymentQuantityOptions';

const FRACTION_PAYMENTS = {
  ANNUAL: 1,
  BIANNUAL: 2,
  QUARTERLY: 4,
  MONTHLY: 12,
};

export const getTitleFromFractionation = (fractionation: Fraction): string => {
  const { installmentNumber } = fractionation;
  if (installmentNumber === FRACTION_PAYMENTS.MONTHLY) {
    return 'Mensual';
  }
  if (installmentNumber === FRACTION_PAYMENTS.QUARTERLY) {
    return 'Trimestral';
  }
  if (installmentNumber === FRACTION_PAYMENTS.BIANNUAL) {
    return 'Semestral';
  }
  return 'Anual';
};

export const getDescriptionFromFractionation = (
  fractionation: Fraction,
  typeDescription?: number,
): string => {
  const { installmentNumber } = fractionation;
  if (
    installmentNumber === FRACTION_PAYMENTS.MONTHLY &&
    typeDescription === 1
  ) {
    return '12';
  }
  if (
    installmentNumber === FRACTION_PAYMENTS.MONTHLY &&
    typeDescription === 2
  ) {
    return '11 cuotas';
  }
  if (installmentNumber === FRACTION_PAYMENTS.MONTHLY) {
    return '12 cuotas';
  }
  if (installmentNumber === FRACTION_PAYMENTS.QUARTERLY) {
    return 'Cuatro pagos';
  }
  if (installmentNumber === FRACTION_PAYMENTS.BIANNUAL) {
    return 'Dos pagos';
  }
  return 'Un solo pago';
};

export const getQuantityTypeFromFractionation = (
  fractionation: Fraction,
): string => {
  const { installmentNumber } = fractionation;
  return installmentNumber === FRACTION_PAYMENTS.ANNUAL ? ANNUAL : OTHER;
};
